const TECHNICAL_ERROR =
  /java\.|javax\.|jakarta\.|org\.(?:springframework|hibernate)|\b(?:SQL|SQLState|JDBC|Hibernate|stack\s*trace|traceback)\b|\b\w+(?:Exception|Error)\b|could not execute (?:statement|query)|\b(?:select\b[\s\S]*?\bfrom|insert\s+into|update\s+\w+\s+set|delete\s+from)\b|\bat\s+[\w.$]+\([^)]*:\d+\)|Http failure response|<!doctype|<\/?(?:html|body|script|pre)\b/i;

/** Return only a readable business message, never framework or database diagnostics. */
export function safeBackendMessage(body: unknown): string | undefined {
  let candidate: unknown = body;
  if (typeof candidate === 'string') {
    const text = candidate.trim();
    if (!text) return undefined;
    try {
      candidate = JSON.parse(text);
    } catch {
      candidate = text;
    }
  }
  if (candidate !== null && typeof candidate === 'object') {
    candidate = (candidate as { message?: unknown }).message;
  }
  if (typeof candidate !== 'string') return undefined;
  const text = candidate.trim();
  return text && text.length <= 1000 && !TECHNICAL_ERROR.test(text)
    ? text
    : undefined;
}

export function getErrorMessage(error: unknown, fallback: string): string {
  if (error && typeof error === 'object' && 'error' in error) {
    // HttpErrorResponse.message is transport diagnostics, not a backend message.
    return safeBackendMessage((error as { error: unknown }).error) ?? fallback;
  }
  return safeBackendMessage(error) ?? fallback;
}

export async function decodeErrorBody(body: unknown): Promise<unknown> {
  if (typeof Blob === 'undefined' || !(body instanceof Blob)) return body;
  try {
    const text =
      typeof body.text === 'function'
        ? await body.text()
        : await new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(String(reader.result ?? ''));
            reader.onerror = () => reject(reader.error);
            reader.readAsText(body);
          });
    try {
      return JSON.parse(text);
    } catch {
      return text;
    }
  } catch {
    return undefined;
  }
}
